import React from 'react';
import { IonToggle } from '@ionic/react';

interface CustomToggleProps {
  label: string;
  subLabel?: string;
  checked?: boolean;
  name?: string;
  onToggle?: (checked: boolean) => void;
  disabled?: boolean;
}

const CustomToggle: React.FC<CustomToggleProps> = ({
  label,
  subLabel,
  checked,
  onToggle,
  name,
  disabled = false,
}) => {
  const handleToggle = (e: any) => {
    if (onToggle) onToggle(e.detail.checked);
  };

  return (
    <IonToggle
      name={name}
      className="font-semibold text-customs-dark-blue toggle-style"
      checked={checked}
      labelPlacement="end"
      alignment="start"
      onIonChange={handleToggle}
      disabled={disabled}
      helperText={subLabel}
    >
      <p className="z-10">{label}</p>
    </IonToggle>
  );
};

export default CustomToggle;
